// extracted by mini-css-extract-plugin
export default {"container":"AvatarStack_container__8866X"};